module.exports = __webpack_public_path__ + "b8e5b79397722f5d26ba92183668b9a1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NE.svg
// module id = hokk
// module chunks = 0